import { Injectable } from '@angular/core';
import { ViewColumnState } from '../../../application-controller/store/states/view-col.states';
import { AgingPeriodListingComponent } from '../aging-period-container/aging-period-listing/aging-period-listing.component';
import { AgingPeriodCreateComponent } from '../aging-period-container/aging-period-create/aging-period-create.component';
import { AgingPeriodEditComponent } from '../aging-period-container/aging-period-edit/aging-period-edit.component';
import { ViewColumn } from '../../../view-column';

@Injectable()

export class AgingPeriodPagesService {

  private initialState: ViewColumnState = {
    firstColumn: new ViewColumn(0, AgingPeriodListingComponent, 'Aging Period Listing', {
      deactivateAdd: false,
      deactivateList: false,
    }),
    secondColumn: null,
    viewCol: [
      new ViewColumn(0, AgingPeriodListingComponent, 'Aging Period Listing', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(1, AgingPeriodCreateComponent, 'Aging Period Create', {
        deactivateAdd: false,
        deactivateList: false
      }),
      new ViewColumn(2, AgingPeriodEditComponent, 'Aging Period Edit', {
        deactivateAdd: false,
        deactivateList: false
      })
    ],
    breadCrumbs: [],
    leftDrawer: [],
    rightDrawer: [],
    singleColumn: false,
    prevIndex: null
  };

  get pages() {
    return this.initialState;
  }

  constructor() { }
}
